import * as React from 'react';
import {connect} from 'react-redux';
import {updateIncrementingAttribute} from "../../../actions/boCoreActions";

const Modal = require('react-modal');

interface Props {
    onRef?: any;
    businessObjectsWrapper: any;

    onSet(config: any): void;
}

interface State {
    isOpen: boolean;
    attribute: any
}

const customStyles = {
    content: {
        border: 'none',
        backgroundColor: "transparent",
        margin: 'auto',
        overflow: 'hidden',
        height: 360
    }
};

class IncrementingConfigModal extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            isOpen: false,
            attribute: null
        };
    }

    componentDidMount(): void {
        if (this.props.onRef) {
            this.props.onRef(this);
        }
    }

    open = (attribute: any) => {
        this.setState({
            isOpen: true,
            attribute
        });
    };

    close = () => {
        this.setState({
            isOpen: false
        });
    };

    onSave = () => {
        updateIncrementingAttribute(this.state.attribute.id, {
            nextValue: $("#nextValue").val(),
            prefix: $("#prefix").val(),
            suffix: $("#suffix").val()
        })
            .then(response => {
                this.close();
                this.props.onSet(response.data);
            })
    };

    render() {
        return (
            <Modal
                isOpen={this.state.isOpen}
                style={customStyles}
                ariaHideApp={false}
                onClose={this.close.bind(this)}
            >
                <div style={{width: 360, height: 265, background: "rgba(0,0,0,0.6)", borderRadius: 5}}
                     className={"container-fluid"}>
                    <div style={{padding: 5, width: "100%", height: "100%"}}>
                        <div style={{width: "100%"}}>
                            <label style={{color: "white", fontSize: 18}}>Next Value</label>
                            <input defaultValue={"1"} id={"nextValue"} style={{width: "100%", height: 40, fontSize: 16}}
                                   min={1}
                                   type={"number"}/>
                        </div>
                        <div style={{width: "100%"}}>
                            <label style={{color: "white", fontSize: 18}}>Prefix</label>
                            <input id={"prefix"}
                                   defaultValue={this.state.attribute ? this.state.attribute.prefix : null}
                                   style={{width: "100%", height: 40, fontSize: 16}} type={"text"}/>
                        </div>
                        <div style={{width: "100%"}}>
                            <label style={{color: "white", fontSize: 18}}>Suffix</label>
                            <input id={"suffix"}
                                   defaultValue={this.state.attribute ? this.state.attribute.suffix : null}
                                   style={{width: "100%", height: 40, fontSize: 16}} type={"text"}/>
                        </div>
                        <div style={{width: "100%", marginTop: 5}}>
                            <button onClick={this.close.bind(this)} style={{float: "left"}} className={"btn"}>Close
                            </button>
                            <button onClick={this.onSave.bind(this)} style={{float: "right"}}
                                    className={"btn btn-primary"}>Save
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        onSet: ownProps.onSet,
        businessObjectsWrapper: state.boCore.businessObjectsWrapper
    }
};

const mapDispatchToProps = () => {
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(IncrementingConfigModal)


// WEBPACK FOOTER //
// ./app/components/bo-core/modals/IncrementingConfigModal.tsx